<div [formGroup]="phoneNumbers">
  <div class="row">
    <div class="col">
      <nh-field [attr.aria-required]="false" id ="{{contactPhoneName+'_home'}}" [mandatory]="false" label="{{'HOME_PHONE' | globalTranslate}}">
        <input type="text" name="home" formControlName="home" [attr.aria-label]="'HOME_PHONE' | globalTranslate" class="form-control" mask="000-000-0000"
          placeholder="XXX-XXX-XXXX" [showMaskTyped]="false">
      </nh-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <nh-field [attr.aria-required]="false" id ="{{contactPhoneName+'_cell'}}" [mandatory]="false" label="{{'CELL_PHONE' | globalTranslate}}">
        <input type="text" name="cell" formControlName="cell" [attr.aria-label]="'CELL_PHONE' | globalTranslate" class="form-control" mask="000-000-0000" pattern=""
          placeholder="XXX-XXX-XXXX" [showMaskTyped]="false">
      </nh-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <nh-field [attr.aria-required]="false" id ="{{contactPhoneName+'_message'}}" [mandatory]="false" label="{{'WORK_PHONE' | globalTranslate}}">
        <input type="text" name="message" formControlName="message" [attr.aria-label]="'WORK_PHONE' | globalTranslate" class="form-control" mask="000-000-0000"
          placeholder="XXX-XXX-XXXX" [showMaskTyped]="false">
      </nh-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <nh-field [attr.aria-required]="false" id ="{{contactPhoneName+'_extension'}}" [mandatory]="false" label="{{'EXTENSION' | globalTranslate}}">
        <input type="text" name="extension" aria-label="extension" [attr.aria-label]="'EXTENSION' | globalTranslate" formControlName="extension" maxlength="6" mask="0*" class="form-control">
      </nh-field>
    </div>
  </div>
</div>